import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useAuth } from '../../../contexts/AuthContext';
import { renderTextWithWhatsAppLinks } from './utils';
import { getClinicRegion } from '../../../utils/clinicRegion';

export default function TranscribeVoiceMailEventValue({ event }) {
  const { conversation_message_id, value, conversation_id } = event;
  const { t } = useLanguage();
  const { currentUser } = useAuth();

  // Get clinic region from current user (already fetched from /auth/me)
  const region = getClinicRegion(currentUser);

  const formatDuration = (seconds) => {
    if (!seconds) return t('voiceMail.noDuration', 'Unknown');
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) {
      return `${mins}:${secs.toString().padStart(2, '0')} ${t('voiceMail.minutes', 'min')}`;
    }
    return `${secs} ${t('voiceMail.seconds', 'sec')}`;
  };

  return (
    <div className="space-y-2">
      {value?.transcription && (
        <div className="text-sm text-gray-700 bg-gray-50 p-3 rounded-md border border-gray-200">
          <div className="whitespace-pre-wrap">
            {renderTextWithWhatsAppLinks(conversation_id, value.transcription, '', region)}
          </div>
        </div>
      )}

      {value?.audio_url && (
        <div className="space-y-2 min-w-[500px]">
          <div className="font-medium text-gray-600 text-sm">
              <a
                href={`https://m.nexicare.ai/tr/${conversation_message_id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 underline"
              >
                {t('voiceMail.downloadAudio', 'Download Audio File')}
              </a>
          </div>
        </div>
      )}

      {value?.total_time && (
        <div className="text-sm text-gray-600">
          <span className="font-medium">⏱️ {t('voiceMail.duration', 'Duration')}:</span> {formatDuration(value.total_time)}
        </div>
      )}
    </div>
  );
}

